import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  selectToolCollection,
  createProductVariation,
  createProduct,
  saveDesign,
} from "../../../actions";
import "./AdminTools.css";

class AdminTools extends React.Component {
  saveDesignAsProductVariation = () => {
    const data = {
      product_id: this.productIDInput.value,
    };
    this.props.createProductVariation(data);
  };

  saveDesignAsProduct = () => {
    const data = {
      type: this.state.product_type,
    };
    this.props.createProduct(data);
  };

  overwriteDesign = () => {
    const data = { overwrite: true };
    this.props.saveDesign(data);
  };

  componentDidMount() {
    // Set 'Upload' as the selected tool in the sidebar
    this.props.selectToolCollection({ activeTool: "Admin" });
    this.setState({ product_type: "customizable" });
  }

  handleProductTypeChange = (e) => {
    this.setState({ product_type: e.target.value });
  };

  render() {
    if (!this.props.user.loggedIn) {
      return null;
    }

    return (
      <div className="tools-container tools-container--admin">
        <h3>Logged in as: {this.props.user.name} </h3>

        <hr />

        <div className="admin__input">
          <input
            type="text"
            name="product_id"
            ref={(input) => {
              this.productIDInput = input;
            }}
          />
          <label>Product ID</label>
        </div>

        <p>
          <button
            className="button button--round"
            onClick={this.saveDesignAsProductVariation}
          >
            {this.props.productVariationStatus.isLoading
              ? "Saving..."
              : "Save Design as NEW PRODUCT VARIATION"}
          </button>
        </p>
        <p>{this.props.productVariationStatus.loaded ? "Saved" : ""}</p>
        <p>
          {this.props.productVariationStatus.error
            ? this.props.status.error
            : ""}
        </p>

        <hr />

        <p>
          <label htmlFor="type_customizable">
            <input
              type="radio"
              id="type_customizable"
              name="product_type"
              value="customizable"
              onChange={this.handleProductTypeChange}
              defaultChecked
            />{" "}
            Customizable (Most common)
          </label>
          <br />
          <label htmlFor="type_retail">
            <input
              type="radio"
              id="type_retail"
              name="product_type"
              value="retail_product"
              onChange={this.handleProductTypeChange}
            />{" "}
            Retail (Grab&amp;Go)
          </label>
          <br />
          <button
            className="button button--round"
            onClick={this.saveDesignAsProduct}
          >
            {this.props.productStatus.isLoading
              ? "Saving..."
              : "Save Design as NEW PRODUCT"}
          </button>
        </p>
        <p>{this.props.productStatus.loaded ? "Saved" : ""}</p>
        <p>{this.props.productStatus.error ? this.props.status.error : ""}</p>

        <hr />

        {this.props.design &&
          this.props.design.id &&
          this.props.admin.action.orderItemID === null && (
            <p>
              <button
                className="button button--round"
                onClick={this.overwriteDesign}
              >
                {this.props.design && this.props.design.isSaving
                  ? "Saving..."
                  : "Save & OVERWRITE Design ID " + this.props.design.id}
              </button>
            </p>
          )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
    productVariationStatus: state.admin.productVariation,
    productStatus: state.admin.product,
    design: state.design.present,
    admin: state.admin,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      selectToolCollection,
      createProductVariation: createProductVariation.request,
      createProduct: createProduct.request,
      saveDesign: saveDesign.request,
    },
    dispatch,
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminTools);
